import { defineMessages } from '@jutro/locale';

export default defineMessages({
    submissionClosed: {
        id: 'jutro-app.pages.submissionIntakeReview.submissionClosed',
        defaultMessage: 'Closed Submission: ',
    },
    submissionUploadFailed: {
        id: 'jutro-app.pages.submissionIntakeReview.submissionUploadFailed',
        defaultMessage: 'Upload Failed',
    },
    loadingSubmissionIntake: {
        id: 'jutro-app.pages.submissionIntakeReview.loadingSubmissionIntake',
        defaultMessage: 'Loading Submission Intake',
    },
    spreadsheetClosed: {
        id: 'jutro-app.pages.submissionIntakeReview.spreadsheetClosed',
        defaultMessage: 'Closed Spreadsheet',
    },
    serviceCallInProgressError: {
        id: 'jutro-app.pages.submissionIntakeReview..serviceCallInProgressError',
        defaultMessage: 'Upload processing in background and may take some time to finish. We will send you an email notification once it is complete.'
    }
});
